"use strict";
exports.__esModule = true;
var react_1 = require("react");
/**
 * Transforms an object whose properties may contain React elements or components to one that contains only scalar
 * values (booleans, numbers, strings). Any React values will be replaced with `<Element name="name" />` tags to
 * be rendered later.
 * @param {Object} [values] The values to transform.
 * @returns {Object} The transformed values.
 */
function transformValues(values) {
    if (!values) {
        return;
    }
    return Object.keys(values).reduce(function (target, name) {
        var value = values[name];
        target[name] = (0, react_1.isValidElement)(value) || typeof value === "function" ? "<Element name=\"".concat(name, "\" />") : value;
        return target;
    }, {});
}
exports["default"] = transformValues;
//# sourceMappingURL=transformValues.js.map